import { render, staticRenderFns } from "./TranslatableInput.vue?vue&type=template&id=8087fefe&scoped=true&"
import script from "./TranslatableInput.vue?vue&type=script&lang=js&"
export * from "./TranslatableInput.vue?vue&type=script&lang=js&"
import style0 from "./TranslatableInput.vue?vue&type=style&index=0&id=8087fefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8087fefe",
  null
  
)

export default component.exports